import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { Link } from 'react-router-dom';
import { parsePhoneNumber } from 'react-phone-number-input'
import GoogleLogin from 'react-google-login';
import FacebookLogin from 'react-facebook-login';
import PhoneInput from 'react-phone-number-input/input'
import { Formik, Form, ErrorMessage, Field } from 'formik';

import config from '../../../config';

import FloatingLabel from "floating-label-react";
import "floating-label-react/styles.css";

import { UserInfo1Schema } from '../validation';
import { updateFormData, loginUsingGoogle, loginUsingFacebook, sendOTP } from '../actions'
import { PAGE_ROUTES } from '../../../constants/pageRoutes';
import ShowSuccessToasts from '../../global/successToast';
import ShowErrorToasts from '../../global/errorToast';
import { FACEBOOK_LOGO, PASSWORD_HIDE, PASSWORD_SHOW } from '../../../constants/images';

const mapStateToProps = state => ({
  registration: state.Registration,
  errors: state.Global.errors,
  successes: state.Global.successes
});

class SignUpForm1 extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isShowingPassword: false
    }

    this.onSignUpByPhone = this.onSignUpByPhone.bind(this);
    this.onGoogleSignup = this.onGoogleSignup.bind(this);
    this.onFacebookSignup = this.onFacebookSignup.bind(this);
    this.toggleSignUpMethod = this.toggleSignUpMethod.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.getSignUpMethod = this.getSignUpMethod.bind(this);
  }

  onSignUpByPhone = (values, { setSubmitting }) => {
    let { dispatch, history, userType } = this.props;
    let { firstName, lastName, phoneNumber, email, password } = values;

    values.userType = userType;
    dispatch(updateFormData(values));
    dispatch(sendOTP(firstName, lastName, userType, phoneNumber, email, password))
      .then(data => {
        setTimeout(() => {
          history.push(PAGE_ROUTES.VERIFY_OTP);
        }, 1000);
      })
      .catch(error => { })
      .finally(() => {
        setSubmitting(false);
      })
  }

  onBack = () => {
    let { history } = this.props;
    history.push(PAGE_ROUTES.CREATE_ACCOUNT);
  }

  handleSubmit = (values, form) => {
    this.onSignUpByPhone(values, form);
  }

  toggleSignUpMethod = (formProps) => {
    formProps.setFieldValue("signUpMethod", this.getSignUpMethod(formProps) === "email" ? "phone" : "email")
  }

  getSignUpMethod = (formProps) => {
    return formProps.values.signUpMethod;
  }

  onGoogleSignup = (response, values) => {
    if (!response.tokenId)
      return;

    let { dispatch, userType } = this.props;
    values.userType = userType;
    dispatch(updateFormData(values));
    dispatch(loginUsingGoogle(response.tokenId, userType));
  }

  onFacebookSignup = (response, values) => {
    if (!response.accessToken)
      return;

    let { dispatch, userType } = this.props;
    values.userType = userType;
    dispatch(updateFormData(values));
    dispatch(loginUsingFacebook(response.accessToken, userType));
  }

  render() {

    const { roleTitle } = this.props;
    const termsAndConditions = "Terms & Conditions";
    const values = this.props.registration.formData;

    return (
      <div className="main-container">
        <ShowSuccessToasts />
        <ShowErrorToasts />
        <div className="main-wrapper">
          <div className="left-section">
            <div className="white-background">
              <div className="content-section">
                <h1 className="title">{`${roleTitle} Details`}</h1>
                <p className="detail-text">Note: Your personal contact information will never be shared directly with other users</p>
                <Formik
                  validationSchema={UserInfo1Schema}
                  initialValues={values}
                  validate={this.handleFormValidation}
                  onSubmit={this.handleSubmit}>
                  {formProps => (
                    <Form>
                      <div className="signin-page">
                        <div className="account-section">
                          <GoogleLogin
                            clientId={config.googleLoginClientId}
                            buttonText="Continue with Google"
                            onSuccess={response => this.onGoogleSignup(response, formProps.values)}
                            cookiePolicy={'single_host_origin'}
                            className="account-box"
                            prompt="select_account"
                          />
                          <div className="fb-box">
                            <FacebookLogin
                              appId={config.facebookLoginAppId}
                              fields="name,email,picture"
                              isMobile={false}
                              callback={response => this.onFacebookSignup(response, formProps.values)}
                              cssClass="account-box"
                              textButton="Continue with Facebook"
                              authType='reauthenticate'
                            />
                            <img src={FACEBOOK_LOGO} className="facebook-icon" alt="email" />
                          </div>
                        </div>
                        <div className="signin-detail">
                          <div className="text-detail">
                            Sign Up
                          </div>
                        </div>
                        <div className="form-section">
                          <div className="row">
                            <div className="col pd-right">
                              <div className="form-group">
                                <FloatingLabel
                                  type="text"
                                  id="name"
                                  className="form-control"
                                  name="firstName"
                                  placeholder="First Name"
                                  value={formProps.values.firstName}
                                  onChange={formProps.handleChange}
                                />
                                <ErrorMessage name='firstName' render={msg => <div className="invalid-feedback">{msg}</div>} />
                              </div>
                            </div>
                            <div className="col pd-left">
                              <div className="form-group">
                                <FloatingLabel
                                  type="text"
                                  id="name"
                                  className="form-control"
                                  name="lastName"
                                  placeholder="Last Name"
                                  value={formProps.values.lastName}
                                  onChange={formProps.handleChange}
                                />
                                <ErrorMessage name='lastName' render={msg => <div className="invalid-feedback">{msg}</div>} />
                              </div>
                            </div>
                          </div>
                          <div>
                            <div className="form-group">
                              <FloatingLabel
                                type="email"
                                id="email"
                                className="form-control"
                                name="email"
                                placeholder="Email Address"
                                value={formProps.values.email}
                                onChange={formProps.handleChange}
                              />
                              <ErrorMessage name='email' render={msg => <div className="invalid-feedback">{msg}</div>} />
                            </div>
                            <div className="form-group">
                              <label className={`floating-label form-control ${formProps.values.phoneNumber ? 'floating' : ''}`} htmlFor="phone">
                                <PhoneInput
                                  country="US"
                                  name="phoneNumber"
                                  id="phoneNumber"
                                  className="form-control"
                                  value={`+1${formProps.values.phoneNumber}`}
                                  onChange={(value) => {
                                    if (!!value) {
                                      const num = parsePhoneNumber(value);
                                      if (num) {
                                        formProps.setFieldValue('phoneNumber', num.nationalNumber);
                                      }
                                    } else {
                                      formProps.setFieldValue("phoneNumber", '');
                                    }
                                  }}
                                />
                                <span>Mobile Phone Number</span>
                                <ErrorMessage name='phoneNumber' render={msg => <div className="invalid-feedback">{msg}</div>} />
                              </label>
                            </div>
                            <div className="form-group">
                              <FloatingLabel
                                type={this.state.isShowingPassword ? 'text' : 'password'}
                                id="password"
                                placeholder="Password"
                                name="password"
                                className="form-control password-control"
                                value={formProps.values.password}
                                onChange={formProps.handleChange}
                              />
                              <ErrorMessage name='password' render={msg => <div className="invalid-feedback">{msg}</div>} />
                              <div className="password-section">
                                <img src={this.state.isShowingPassword ? PASSWORD_SHOW : PASSWORD_HIDE}
                                  className="password-icon" alt="password"
                                  onClick={() => { this.setState({ isShowingPassword: !this.state.isShowingPassword }) }} />
                              </div>
                            </div>
                          </div>
                          <div className="form-group mt-5 mb-4">
                            <p className='detail-text'>
                              Please review the CollegeWeekends.com <a href={PAGE_ROUTES.TERMS_CONDITIONS} target="_blank">{termsAndConditions} </a>
                              and <a href={PAGE_ROUTES.PRIVACY_POLICY} target="_blank">Privacy Policy</a> carefully.
                            </p>
                            <div className="checkbox-section">
                              <input
                                name="terms"
                                type="checkbox"
                                style={{ width: 15, height: 15 }}
                                className="form-control"
                                checked={formProps.values.terms}
                                onChange={formProps.handleChange}
                              />
                              <p className="detail-text">
                                I have read and agreed to the CollegeWeekends.com <a href={PAGE_ROUTES.TERMS_CONDITIONS} target="_blank">{termsAndConditions} </a>
                                and <a href={PAGE_ROUTES.PRIVACY_POLICY} target="_blank">Privacy Policy</a>.
                              </p>
                              <ErrorMessage name='terms' render={msg => <div className="invalid-feedback agree-validation">{msg}</div>} />
                            </div>
                          </div>
                          <div className="combo-button">
                            <div className="back-button">
                              <button type="button" className="btn dark" onClick={this.onBack}>Back</button>
                            </div>
                            <div className="signin-button">
                              <button type="submit" className="btn primary">Next</button>
                            </div>
                          </div>
                          <div className="no-account-detail">
                            <p className="account-text">Already have an account? <Link to='/login' className="signup-link">Sign In</Link></p>
                          </div>
                        </div>
                      </div>
                    </Form>
                  )}
                </Formik>

              </div>
            </div>
          </div>
          <div className="right-section">
            <div className="bg-image"></div>
          </div>
        </div>
      </div >
    )
  }
}

export default withRouter(connect(mapStateToProps)(SignUpForm1));
